// extracted by mini-css-extract-plugin
export default {"notFoundPage":"NotFound_notFoundPage__51tXw","banner":"NotFound_banner__QTkLL","container":"NotFound_container__1fusd"};